export default __webpack_public_path__ + "static/media/gallery_04.2cf8ef2e.jpg";